export default "__VITE_ASSET__2d663b98__"